import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
// import { EModuleWidth } from 'src/types/common/module';
import { OriSelect } from 'src/components/Antd';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { moduleWidthSelect } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';

const Option = OriSelect.Option;

const ModuleWidth = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { options, disabled } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('general.moduleWidth')}>
        <Field name={moduleWidthSelect}>
          <OriSelect disabled={disabled} size='large'>
            {(options || []).map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default ModuleWidth;
